
<div v-if="$vuetify.breakpoint.lgAndUp">
	<v-menu offset-y close-on-click style="overflow-y: auto !important">
		<template #activator="{ on, attrs }">
			<v-list-item v-bind="attrs" v-on="on">
				<v-list-item-avatar v-if="!imageObj.logo" horizontal>
					<v-img :src="no_avatar"></v-img>
				</v-list-item-avatar>
				<!-- <div v-else> -->
				<!-- <v-menu v-model="showNotificationMenu" :position-x="notificationMenu_x" :position-y="notificationMenu_y" absolute>
						<v-card min-width="300">
							<v-card-title class="justify-center text-center pb-1 mb-0">Notifications</v-card-title>
						</v-card>
					</v-menu>
					<v-badge v-if="notificationCount > 0" bordered overlap bottom offset-x="35" offset-y="25" color="primary" @click="doShowNotificationMenu">
						<template #default>
							<v-list-item-avatar horizontal @click="doShowNotificationMenu">
								<v-img :src="imageObj.logo"></v-img>
							</v-list-item-avatar>
						</template>
						<template #badge @click="doShowNotificationMenu">
							<v-icon v-if="notificationIcon" class="shakey" @click="doShowNotificationMenu">{{ notificationIcon }}</v-icon>
							<p v-else @click="doShowNotificationMenu">{{ notificationCount }}</p>
						</template>
					</v-badge> -->
				<v-list-item-avatar v-else horizontal>
					<v-img :src="imageObj.logo"></v-img>
				</v-list-item-avatar>
				<!-- </div> -->

				<v-list-item-content @click="showUserMenu">
					<v-list-item-title v-if="user" :style="`color: ${customColor} !important;`" color="red" class="text--secondary font-weight-bold">{{
						usersName
					}}</v-list-item-title>
					<v-list-item-subtitle :style="`color: ${customColor} !important;`">{{ usersProfession }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</template>

		<!-- <v-menu v-model="userMenu" offset-y close-on-click :position-x="userMenu_x" :position-y="userMenu_y" absolute max-height="412"> -->
		<v-card elevation="3" style="overflow-y: hidden !important; overflow-x: hidden !important">
			<v-card-actions>
				<v-row>
					<v-col>
						<v-row v-if="showWallet" class="pb-0 ml-1 mr-1 ma-3">
							<v-btn :disabled="profileDisabled" dark color="wallet" block @click="openWallet">Redeem Credits</v-btn>
						</v-row>
						<v-row class="pb-0 ml-1 mr-1 mb-3 ma-3"
							><v-btn :disabled="profileDisabled" to="/company/profile" router color="secondary" block @click="handleEditProfile">Edit Profile</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :disabled="accountDisabled" color="secondary" block @click="handleAccountSettings">Account Settings</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :disabled="accountDisabled" color="secondary" block to="/company/user-management">User Management</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" router :href="menuLinks.faq" target="_blank" color="secondary" block>FAQ</v-btn></v-row>
						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :loading="apiRequest" router :href="menuLinks.blog" target="_blank" color="secondary" block>Blog</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"
							><v-btn :loading="apiRequest" router :href="menuLinks.contact" target="_blank" color="secondary" block>Contact Us</v-btn></v-row
						>
						<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" color="secondary" block @click="signOut">Sign Out</v-btn></v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
		<!-- </v-menu> -->
	</v-menu>
</div>
